import { h, Component } from "preact";
import classnames from 'classnames/dedupe';
import { MDCTabBar, MDCTabBarScroller } from "@material/tabs";

import '@material/tabs/mdc-tabs.scss';
import './index.scss';
/**
 * @prop indicator-accent = false
 * @prop icon-tab-bar = false
 * @prop icons-with-text = false
 * @prop scroller = false
 */
export default class Tabs extends Component {
  constructor() {
    super();
    this.componentName = "tab-bar";
    this._mdcProps = [
      "indicator-accent",
      "icon-tab-bar",
      "icons-with-text",
      "scroller"
    ];
  }
  componentDidMount() {
    this.MDComponent = new MDCTabBar(this.control);
    if(this.props.contentClass){
      let panels = document.querySelector('.'+this.props.contentClass);
      function updatePanel(index) {
        let activePanel = panels.querySelector('.mdc-panel.active');
        if (activePanel) {
          activePanel.classList.remove('active');
        }
        let newActivePanel = panels.querySelector('.mdc-panel:nth-child(' + (index + 1) + ')');
        if (newActivePanel) {
          newActivePanel.classList.add('active');
        }
      }

      this.MDComponent.listen('MDCTabBar:change', function ({detail: tabs}) {
        let nthChildIndex = tabs.activeTabIndex;

        updatePanel(nthChildIndex);
      });
    }
  }
  componentWillUnmount() {
    this.MDComponent.destroy && this.MDComponent.destroy();
  }
  render({
  	'class': className,
	children,
	scroller,
	...props
  }){
	 	const classes = classnames('mdc-tab-bar',{
	 		'mdc-tab-bar-scroller__scroll-frame__tabs' : scroller
	 	}, className);
		return(
		 <nav
	        class={classes}
	        role="tablist"
	        {...props}
	        ref={control => (this.control = control)}
	      >
	        {children}
	        <span class="mdc-tab-bar__indicator" />
	      </nav>
		);
	}
}

class TabBarScroller extends Component {
  constructor() {
    super();
    this.componentName = "tab-bar-scroller";
  }
  componentDidMount() {
    this.MDComponent = new MDCTabBarScroller(this.control);
  }
  componentWillUnmount() {
    this.MDComponent.destroy && this.MDComponent.destroy();
  }
  render({
  	'class': className,
  	children,
	...props
  }){
  	const classes = classnames('mdc-tab-bar-scroller', {}, className);
    return (
      <div class={classes} {...props} ref={control => (this.control = control)}>
        <div className="mdc-tab-bar-scroller__indicator mdc-tab-bar-scroller__indicator--back">
          <a
            className="mdc-tab-bar-scroller__indicator__inner material-icons"
            href="#"
            aria-label="scroll back button"
          >
            &lsaquo;
          </a>
        </div>
        <div className="mdc-tab-bar-scroller__scroll-frame">
          {children}
        </div>
        <div className="mdc-tab-bar-scroller__indicator mdc-tab-bar-scroller__indicator--forward">
          <a
            className="mdc-tab-bar-scroller__indicator__inner material-icons"
            href="#"
            aria-label="scroll forward button"
          >
            &rsaquo;
          </a>
        </div>
      </div>
    );
  }
}

/**
 * @prop active = false
 */
class Tab extends Component {
  constructor() {
    super();
    this.componentName = "tab";
    this._mdcProps = ["active"];
  }
  render({
  	'class': className,
  	children, 
  	active,
  	...props
  }){
  	const classes = classnames('mdc-tab',{'mdc-tab--active': active}, className);
    return (
      <a class={classes} role="tab" {...props} ref={control => (this.control = control)}>
        {children}
      </a>
    );
  }
}

class TabIconLabel extends Component {
  constructor() {
    super();
    this.componentName = "tab__icon-text";
  }
  render({...props}){
    return (
      <span {...props} ref={control => (this.control = control)}>
        {props.children}
      </span>
    );
  }
}

Tabs.TabBarScroller = TabBarScroller;
Tabs.Tab = Tab;
Tabs.TabIconLabel = TabIconLabel;


// WEBPACK FOOTER //
// ../q-mdc/elements/material-tabs/index.js